import Group from './Group.js';

class GroupFactory {
    constructor() {
        this.groups = [];
    }

    useGroup(tags, channelMixer, groupNumber, sequencerEngine, subSequence) {
        if (this.groups.length === 0 || !window.explore) {
            return new Group(
                tags,
                channelMixer,
                groupNumber,
                sequencerEngine,
                subSequence);
        }

        let group = this.groups.pop();
        group.subSequence = subSequence;
        group.channelMixer = channelMixer;
        group.sequencerEngine = sequencerEngine;
        group.tags = tags;
        group.groupNumber = groupNumber;
        group.subSequence = subSequence;
        return group;
    }

    releaseGroup(group) {
        if (window.explore) {
            group.outputNode.disconnect();
            group.tracks = [];
            group.updateRedux();
            group.effectsChain.clear();
            this.groups.push(group);
        } else {
            group.dispose();
        }
    }
}

export const groupFactory = new GroupFactory();
